
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/lyziarske-stredisko",
      function () {
        return require("private-next-pages/[region]/[resort]/lyziarske-stredisko.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/lyziarske-stredisko"])
      });
    }
  